import React from 'react';
import classes from './others.module.css';

const Others = () => {
    return <div className={classes.othersWrap}>. . . . . . . . . . . . . . . . . .</div>;
};

export default Others;
